const DEFAULT_XML_6_8 = `<xml xmlns="https://developers.google.com/blockly/xml">
  <block type="math_arithmetic" x="50" y="50">
    <field name="OP">ADD</field>
    <value name="A">
      <block type="math_arithmetic">
        <field name="OP">ADD</field>
        <value name="A">
          <block type="math_arithmetic">
            <field name="OP">ADD</field>
            <value name="A">
              <block type="math_arithmetic">
                <field name="OP">ADD</field>
                <value name="A">
                  <block type="db_variable"><field name="VAR_NAME">pt1</field></block>
                </value>
                <value name="B">
                  <block type="db_variable"><field name="VAR_NAME">notebook1</field></block>
                </value>
              </block>
            </value>
            <value name="B">
              <block type="db_variable"><field name="VAR_NAME">enrichment1</field></block>
            </value>
          </block>
        </value>
        <value name="B">
          <block type="db_variable"><field name="VAR_NAME">half_yearly</field></block>
        </value>
      </block>
    </value>
    <value name="B">
      <block type="math_arithmetic">
        <field name="OP">ADD</field>
        <value name="A">
          <block type="math_arithmetic">
            <field name="OP">ADD</field>
            <value name="A">
              <block type="math_arithmetic">
                <field name="OP">ADD</field>
                <value name="A">
                  <block type="db_variable"><field name="VAR_NAME">pt2</field></block>
                </value>
                <value name="B">
                  <block type="db_variable"><field name="VAR_NAME">notebook2</field></block>
                </value>
              </block>
            </value>
            <value name="B">
              <block type="db_variable"><field name="VAR_NAME">enrichment2</field></block>
            </value>
          </block>
        </value>
        <value name="B">
          <block type="db_variable"><field name="VAR_NAME">annual</field></block>
        </value>
      </block>
    </value>
  </block>
</xml>`;

const DEFAULT_XML_9_10 = `<xml xmlns="https://developers.google.com/blockly/xml">
  <block type="math_arithmetic" x="50" y="50">
    <field name="OP">ADD</field>
    <value name="A">
      <block type="math_arithmetic">
        <field name="OP">ADD</field>
        <value name="A">
          <block type="math_arithmetic">
            <field name="OP">ADD</field>
            <value name="A">
              <block type="math_arithmetic">
                <field name="OP">ADD</field>
                <value name="A">
                  <block type="best_percent_of">
                    <field name="PERCENT">10</field>
                    <value name="A"><block type="db_variable"><field name="VAR_NAME">pre_mid</field></block></value>
                    <value name="B"><block type="db_variable"><field name="VAR_NAME">mid</field></block></value>
                    <value name="C"><block type="db_variable"><field name="VAR_NAME">post_mid</field></block></value>
                  </block>
                </value>
                <value name="B"><block type="db_variable"><field name="VAR_NAME">multiple_assessment</field></block></value>
              </block>
            </value>
            <value name="B"><block type="db_variable"><field name="VAR_NAME">portfolio</field></block></value>
          </block>
        </value>
        <value name="B"><block type="db_variable"><field name="VAR_NAME">enrichment</field></block></value>
      </block>
    </value>
    <value name="B">
      <block type="db_variable"><field name="VAR_NAME">annual</field></block>
    </value>
  </block>
</xml>`;

const SCHEMA_6_8 = {
  terms: ['Term 1', 'Term 2'],
  columns: {
    'Term 1': [
      { id: 'pt1', label: 'Periodic Test (10)', max: 10 },
      { id: 'notebook1', label: 'Note Book (5)', max: 5 },
      { id: 'enrichment1', label: 'Sub-Enrichment (5)', max: 5 },
      { id: 'half_yearly', label: 'Half Yearly Exam (80)', max: 80 }
    ],
    'Term 2': [
      { id: 'pt2', label: 'Periodic Test (10)', max: 10 },
      { id: 'notebook2', label: 'Note Book (5)', max: 5 },
      { id: 'enrichment2', label: 'Sub-Enrichment (5)', max: 5 },
      { id: 'annual', label: 'Annual Exam (80)', max: 80 }
    ]
  },
  defaultXml: DEFAULT_XML_6_8,
  formulas: {
    'Total': `((marks['pt1'] || 0) + (marks['notebook1'] || 0) + (marks['enrichment1'] || 0) + (marks['half_yearly'] || 0)) + ((marks['pt2'] || 0) + (marks['notebook2'] || 0) + (marks['enrichment2'] || 0) + (marks['annual'] || 0))`
  }
};

const SCHEMA_9_10 = {
  terms: ['Final'],
  columns: {
    'Final': [
      { id: 'pre_mid', label: 'Pre Mid (50)', max: 50 },
      { id: 'mid', label: 'Mid Term (50)', max: 50 },
      { id: 'post_mid', label: 'Post Mid (50)', max: 50 },
      { id: 'multiple_assessment', label: 'Multiple Assess (5)', max: 5 },
      { id: 'enrichment', label: 'Sub-Enrichment (5)', max: 5 },
      { id: 'portfolio', label: 'Portfolio (5)', max: 5 },
      { id: 'annual', label: 'Annual Exam (80)', max: 80 }
    ]
  },
  defaultXml: DEFAULT_XML_9_10,
  formulas: {
    'Final': `(Math.max((marks['pre_mid'] || 0) + (marks['mid'] || 0), (marks['mid'] || 0) + (marks['post_mid'] || 0), (marks['pre_mid'] || 0) + (marks['post_mid'] || 0)) / 2) * 0.1 + (marks['multiple_assessment'] || 0) + (marks['enrichment'] || 0) + (marks['portfolio'] || 0) + (marks['annual'] || 0)`
  }
};

export const MARKING_SCHEMES = {
  'Class VI': SCHEMA_6_8,
  'Class VII': SCHEMA_6_8,
  'Class VIII': SCHEMA_6_8,
  'Class IX': SCHEMA_9_10,
  'Class X': SCHEMA_9_10
};

export const GRADE_SCALE = [
  { min: 91, max: 100, grade: 'A1' },
  { min: 81, max: 90.99, grade: 'A2' },
  { min: 71, max: 80.99, grade: 'B1' },
  { min: 61, max: 70.99, grade: 'B2' },
  { min: 51, max: 60.99, grade: 'C1' },
  { min: 41, max: 50.99, grade: 'C2' },
  { min: 33, max: 40.99, grade: 'D' },
  { min: 0, max: 32.99, grade: 'E (Failed)' }
];

export function getGrade(score) {
  if (score == null || isNaN(score)) return '';
  const match = GRADE_SCALE.find(g => score >= g.min && score <= g.max);
  return match ? match.grade : '';
}
